// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ReconciliationManualModeController = function ($rootScope, $scope, $routeParams, $location, ReconciliationManualMode,
   SharedParameters, salesEntitiesService, DatepickerUtils) {
        $scope.back = function (key, value) {
        if (key) {
            SharedParameters.setValue(key, value);
        }

        history.back();
        return false;
    };

    $scope.transaction = {};
    $scope.saveTransaction = function () {
        if (!$rootScope.isValid($scope.form)) 
            return;

        $scope.transaction.ContractId = $routeParams.contractId;

        let displayNotification = function (message) {
            if (message) {
                let successDelay = 10000;
                let delay = message.IsSuccessMsg ? successDelay : successDelay + 5000;

                $scope.notifications.push(message);

                setTimeout(function () {
                    $scope.$apply(function () {
                        $scope.notifications.splice(0, 1);
                    });
                }, delay);
            }
        };

        ReconciliationManualMode.update(angular.toJson($scope.transaction), function (list) {
            if (list.length === 0)
                displayNotification({ IsSuccessMsg: true });
            else
                list.forEach(function (log) {
                    let successMessage = { IsSuccessMsg: true };
    
                    if (log.CustomerId) {
                        successMessage.CustomerName = log.CustomerName;
                        successMessage.CustomerId = log.CustomerId;
                        successMessage.LedgerInfoId = log.LedgerInfoId;
                    }
    
                    displayNotification(successMessage);
    
                    if ($scope.transaction.BookingType === 'Chargeback' || log.IsRecurringPaymentsStopped) {
                        let infoMessage = {
                            IsInfoMsg: true,
                            IsChargeback: $scope.transaction.BookingType === 'Chargeback',
                            IsRecurringPaymentsStopped: log.IsRecurringPaymentsStopped
                        };
    
                        displayNotification(infoMessage);
                    }
                });

            let currency = $scope.transaction.Currency;
            $scope.transaction = { };
            setBookingDate();
            $scope.transaction.Currency = currency;
        });
    };

    function setBookingDate() {
        $scope.transaction.BookingDate = DatepickerUtils.toBerlinMidnightTime(new Date());
    }

    $scope.CreationDate = new Date();
    setBookingDate();
    
    $scope.isAmountValid = function () {
        if ($scope.transaction && $scope.transaction.BookingType === 'Chargeback' && $scope.transaction.Amount)
            return $scope.transaction.Amount < 0;

        return true;
    };

    $scope.displayAutoAssignChargeBackMsg = function () {
        var result = false;

        if ($scope.transaction && $scope.transaction.BookingType === 'Chargeback' && $scope.transaction.Purpose) {
            var refCodeRegEx = /^[A-Z]{4}-[A-Z]{4}$/,
                words = $scope.transaction.Purpose.split(" ").filter(Boolean);

            for (var i = 0; i < words.length; i++) {
                if (refCodeRegEx.test(words[i])) {
                    result = true;
                    break;
                }
            }
        }

        return result;
    };

    $scope.notifications = [];

    $scope.useQRInvoice = false;
    salesEntitiesService.query({}, function (response) {
        for (var i = 0; i < response.length; i++) {
            let pdfSettings = response[i].PdfSettings;
            if (!!pdfSettings.QRInvoiceType) {
                $scope.useQRInvoice = true;
                return;
            }
        }
    });
    
};
ReconciliationManualModeController.$inject = ['$rootScope', '$scope', '$routeParams', '$location',
    'ReconciliationManualMode', 'SharedParameters', 'SalesEntities', 'DatepickerUtils'];
